// Lib
import { useRef } from 'react';
import { nanoid } from 'nanoid/non-secure';

export default () => {
    const uniqueId = useRef(`uid-${nanoid()}`);
    return uniqueId.current;
};
